// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"_n-z","badgeLink":"ao-z","category":"bo-z"};